@if (this.data) {
  <div class="card-list p-3">
    @for (item of data; track item) {
      <div class="card-col">
        <app-kanban-view-document [item]="item"></app-kanban-view-document>
      </div>
    }
  </div>
}
